import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const IncentiveBanner: FunctionalComponent<IIconProps> = () => (
  /*@ts-ignore*/
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <rect width="48" height="48" fill="white" />
    <path
      d="M45.4327 29.8553C45.3923 30.0262 45.3177 30.1598 45.2027 30.2406L36.7032 35.0264L28.1665 37.5094C27.1316 37.8078 26.0626 37.96 24.9874 37.9663L17.0566 38.0129C16.0186 38.0191 15.0211 38.4293 14.2783 39.1596L11.525 41.8695L3.60974 37.2515L9.98045 30.7627C12.911 27.8011 17.2866 27.1547 20.8479 28.8297L20.8883 28.867L27.4517 28.8297C29.7048 28.8173 31.0628 29.445 31.877 30.2593C32.6042 30.9802 32.9026 31.8473 33.0269 32.5341L33.4495 32.8417C33.4495 32.8417 39.121 30.4644 41.4113 29.5662C43.2511 28.8515 44.5843 29.1871 45.4327 29.8553Z"
      fill="#C49A6C"
    />
    <path
      d="M37.2098 15.6346L31.7558 21.5111L25.8793 16.0541C21.6839 12.1602 27.141 6.2836 31.3332 10.1806C35.2302 5.98526 41.1068 11.4392 37.2098 15.6346Z"
      fill="#97C93C"
    />
    <path
      d="M20.6801 31.6173H32.02C32.02 30.8341 32.02 26.9247 26.4977 26.9247H20.0679"
      stroke="#8B5E3C"
      stroke-width="1.61061"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.0307 26.8906C16.5532 25.228 12.2615 25.8371 9.37448 28.721L2 36.139"
      stroke="#8B5E3C"
      stroke-width="1.61061"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9135 42L14.6233 39.3616C15.3536 38.6499 16.3357 38.2522 17.3519 38.2522H25.1241C26.1776 38.2522 27.228 38.1061 28.2442 37.8233L36.6225 35.4397L44.9759 30.8C45.8833 30.166 44.4351 26.1012 40.1745 27.7327C37.9246 28.5967 32.3557 30.8932 32.3557 30.8932"
      stroke="#8B5E3C"
      stroke-width="1.61061"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.024 11.7625C23.2875 10.566 24.3161 8.88789 25.2919 8.67346"
      stroke="#458500"
      stroke-width="1.61061"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.3643 24.8954L40.2615 16.1349C46.6322 9.85123 37.8344 0.929137 31.4606 7.20972C25.1769 0.839014 16.2548 9.63681 22.5385 16.0106L29.0864 22.6548"
      stroke="#458500"
      stroke-width="1.61061"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default IncentiveBanner;
